
import React from "react";
import { Textarea } from "@/components/ui/textarea";

interface EmailContentEditorProps {
  content: string;
  onChange: (value: string) => void;
  isLoading: boolean;
}

const EmailContentEditor = ({ content, onChange, isLoading }: EmailContentEditorProps) => {
  return (
    <Textarea
      value={content}
      onChange={(e) => onChange(e.target.value)}
      className="min-h-[300px] font-mono text-sm"
      placeholder={
        isLoading 
          ? "Generating your forwardable email template..." 
          : "Your forwardable email template will appear here"
      }
    />
  );
};

export default EmailContentEditor;
